import React, { memo } from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';

function PayoffsTable() {
  const { data: payoffs } = useQuery({
    queryKey: ['payoffs'],
    queryFn: ReportService.getPayoffs,
  });

  // Uncomment to debug the structure
  // if (payoffs && payoffs.length > 0 && payoffs[0].payoff_statements && payoffs[0].payoff_statements.length > 0) {
  //   console.log('First payoff statement:', payoffs[0].payoff_statements[0]);
  // }

  const getLatestPayoffDate = (payoffStatements) => {
    if (!payoffStatements || !payoffStatements.length) return null;

    // Sort by created_at in descending order and get the first one
    const sortedStatements = [...payoffStatements].sort(
      (a, b) => b.created_at - a.created_at
    );
    return sortedStatements[0].created_at;
  };

  const cols = [
    {
      title: 'Property',
      keys: ['_property.address_line_1'],
      format: (value, row) => {
        const addressLine1 = value || '';
        const addressLine2 = row._property?.address_line_2;
        return addressLine2 ? `${addressLine1}, ${addressLine2}` : addressLine1;
      },
      link: (row) => `/loans/${row.id}?tab=Property`,
    },
    {
      title: 'Borrower',
      keys: ['doesntmatter'],
      format: (_, row) =>
        row?._borrower_primary?.TIN_type === 'EIN'
          ? row._borrower_primary?.entity_name
          : `${row._borrower_primary?.first_name} ${row._borrower_primary?.last_name}`,
      link: (row) => `/loans/${row.id}?tab=Borrowers`,
    },
    {
      title: 'Date Created',
      keys: ['payoff_statements'],
      format: (value) => {
        const latestDate = getLatestPayoffDate(value);
        return latestDate ? moment(latestDate).format('M/D/YY') : '-';
      },
    },
    {
      title: 'Expiration Date',
      keys: ['payoff_statements'],
      format: (value) => {
        if (!value || !value.length) return '-';
        const latestStatement = [...value].sort(
          (a, b) => b.created_at - a.created_at
        )[0];
        return latestStatement.expiration_date
          ? moment(latestStatement.expiration_date).format('M/D/YY')
          : '-';
      },
    },
    {
      title: 'Download',
      type: 'downloadDocButton',
      keys: ['payoff_statements'],
      format: (value) => {
        if (!value || !value.length) return null;

        const latestStatement = [...value].sort(
          (a, b) => b.created_at - a.created_at
        )[0];

        // Return an object with both docId and docName
        return {
          docId: latestStatement.id || latestStatement.document_id,
          docName: `Payoff_Statement_${moment(
            latestStatement.created_at
          ).format('YYYY-MM-DD')}.pdf`,
        };
      },
    },
  ];

  return <Table cols={cols} rows={payoffs} title="Payoff Statements" />;
}

export default memo(PayoffsTable);
